import { useEffect } from "react";
import CustomDialog from "../../../components/common/dialogs/CustomDialog";
import { useUploadBlDocumentMutation } from "../../../services/bl-export/BLExportService";
import FormUploadDocument from "../forms/FormUploadDocument";

interface props {
  id_bl?: number;
  onClose: () => void;
  callback: () => void;
}

const ModalUploadDocument = ({ id_bl, onClose, callback }: props) => {
  const [upload, { isLoading, isSuccess, isError, reset }] =
    useUploadBlDocumentMutation();

  const handleClose = () => {
    onClose();
    setTimeout(reset, 200);
  };

  useEffect(() => {
    if (isSuccess === true) {
      callback();
      return;
    }
  }, [isSuccess, callback]);

  return (
    <CustomDialog
      maxWidth={isError === true || isSuccess ? "xs" : "sm"}
      isOpen={Boolean(id_bl)}
      handleClose={handleClose}
      title="Subir Carta/BL"
      hideActionButtons
      isSuccess={isSuccess}
      successMessage="El archivo se cargo correctamente"
      isError={isError}
      errorMessage="No se pudo subir el archivo. Intente luego"
    >
      <FormUploadDocument
        submit={(type, file) => {
          upload({
            id_bl: Number(id_bl),
            file,
            file_type: type,
          });
        }}
        id_bl={Number(id_bl)}
        onCancel={onClose}
        isLoading={isLoading}
      />
    </CustomDialog>
  );
};

export default ModalUploadDocument;
